import { motion } from "framer-motion";
import { Check, PartyPopper } from "lucide-react";

const evenements = [
  "Salons des vins",
  "Portes ouvertes de domaines viticoles",
  "Foires et marchés gastronomiques",
  "Festivals et manifestations culturelles",
  "Événements d'entreprises",
  "Réceptions privées & événements sur mesure",
];

const Evenements = () => {
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section data-testid="evenements-section" id="evenements" className="py-24 lg:py-32 bg-[#2C2A28] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <span className="text-sm uppercase tracking-[0.3em] text-creme font-500">Pour les professionnels</span>
            <h2 className="font-heading text-4xl sm:text-5xl mt-3 tracking-tight leading-tight">
              Organisateurs d'événements,<br /> faites appel à Escarg'Holala
            </h2>
            <div className="space-y-4 mt-6 text-white/75 text-lg leading-relaxed">
              <p>
                Depuis de nombreuses années, nous accompagnons vignerons et organisateurs de salons
                ou d'événements en Bourgogne. Notre spécialité : nos Croq'Escargots
                servis dans une ambiance conviviale et gourmande qui séduisent les visiteurs.
              </p>
              <p>
                Restauration chaude, animation gourmande ou mise en valeur des produits de notre terroir :
                nous étudions avec vous la formule la plus adaptée. Très bien équipés, nous savons répondre
                aux <strong className="text-white">grands événements</strong> comme aux réceptions plus intimes.
              </p>
              <p>
                Nous proposons également une <strong className="text-white">gamme dédiée aux restaurateurs</strong>{" "}
                et étudions le besoin de chacun, pour une offre sur mesure adaptée à votre établissement.
              </p>
            </div>

            <div className="mt-8 flex items-center gap-4">
              <button
                data-testid="evenements-contact-btn"
                onClick={() => go("contact")}
                className="rounded-full bg-bordeaux text-white font-600 px-7 py-3.5 hover:bg-bordeaux-dark transition-all hover:-translate-y-0.5"
              >
                Demander un devis
              </button>
              <span className="text-white/60 text-sm">Déplacement selon vos besoins</span>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="rounded-[2rem] bg-white/5 border border-white/12 p-8 lg:p-10 backdrop-blur-sm"
          >
            <div className="flex items-center gap-3 text-creme">
              <PartyPopper size={22} />
              <span className="font-heading text-2xl">Nous intervenons lors de</span>
            </div>
            <ul className="mt-6 space-y-4">
              {evenements.map((e, i) => (
                <li key={e} data-testid={`evenement-${i}`} className="flex items-start gap-3 text-white/85">
                  <span className="mt-0.5 w-6 h-6 rounded-full bg-creme/15 text-creme flex items-center justify-center shrink-0">
                    <Check size={14} />
                  </span>
                  <span>{e}</span>
                </li>
              ))}
            </ul>
            <p className="mt-8 pt-6 border-t border-white/10 font-heading text-2xl text-creme italic leading-snug">
              Escarg'Holala, le goût de la Bourgogne au cœur de vos manifestations.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Evenements;
